// extracted by mini-css-extract-plugin
export default {"textCarouselItem":"intro-section_textCarouselItem__GGbHN","slogan":"intro-section_slogan__BY8dF"};